import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../App";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { ArrowLeft, Lock, CheckCircle } from "lucide-react";

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords don't match"); return; }
    if (password.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    if (!token) { toast.error("Missing reset token"); return; }
    setSubmitting(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setDone(true);
      toast.success("Password updated");
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed");
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="text-white/50 hover:text-[#C5A059] text-sm flex items-center gap-2 mb-6">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
        <div className="bg-[#0F0F0F] border border-white/10 rounded-sm p-8">
          {done ? (
            <div className="text-center space-y-4 py-6" data-testid="reset-done">
              <CheckCircle className="w-16 h-16 mx-auto text-emerald-400" />
              <h2 className="text-white text-xl font-semibold">Password updated</h2>
              <p className="text-white/60 text-sm">Redirecting you to sign in...</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
              <h1 className="text-2xl font-bold text-white">Set a new password</h1>
              <p className="text-white/40 text-sm mb-2">Choose a strong password (min 8 characters).</p>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/30" />
                <Input type="password" placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-dark pl-10" required data-testid="new-password" />
              </div>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/30" />
                <Input type="password" placeholder="Confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="input-dark pl-10" required data-testid="confirm-password" />
              </div>
              <Button type="submit" className="btn-gold w-full" disabled={submitting} data-testid="reset-submit">
                {submitting ? "Updating..." : "Update Password"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
